import api from '../Services/AxiosInstance';

export class ListAdhService {
    
         getAllListAdhByPeriod = async (period) => {
            const userId = 'dev1'; 
      const headers = { user_id: userId };
            try {
              const response = await api.get(`/Adherent/list`, {headers});
              return response.data;
            } catch (error) {
              console.error('Erreur lors de la récupération des données :', error);
            
            }
          };
  
    
}